// Zarządzanie zgodą na cookies / analitykę (GA4 + Consent Mode v2).
// Jedno źródło prawdy dla banera, gatsby-ssr i ewentualnych przyszłych komponentów.
//
// Mechanika:
// - GA4 ładuje się od razu, ale z domyślnym consent = "denied" (patrz gatsby-ssr.tsx).
//   Dopóki user nie zaakceptuje, Google nie zapisuje żadnych cookies ani identyfikatorów.
// - Po kliknięciu "Akceptuję" wołamy gtag('consent','update', granted) → pełne śledzenie.
// - Wybór trzymamy w localStorage, żeby nie pytać przy każdej wizycie.

export const CONSENT_KEY = "cookie-consent"; // localStorage key
export type ConsentValue = "granted" | "denied";

// Measurement ID z GA4 — wstrzykiwany w czasie build z .env (GATSBY_GA4_ID).
// Gdy pusty, cała analityka jest wyłączona (strona działa normalnie).
export const GA4_ID: string =
  (typeof process !== "undefined" && process.env.GATSBY_GA4_ID) || "";

// Odczyt zapisanej decyzji. null = user jeszcze nie wybrał → pokazujemy baner.
export function getStoredConsent(): ConsentValue | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(CONSENT_KEY);
    return v === "granted" || v === "denied" ? v : null;
  } catch {
    return null;
  }
}

// Zapis decyzji + natychmiastowa aktualizacja Consent Mode w gtag.
export function setConsent(value: ConsentValue): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* tryb prywatny / brak storage — i tak zaktualizujemy gtag poniżej */
  }
  applyConsent(value);
}

// Wysyła stan zgody do Google Consent Mode v2.
// Aktualizujemy zarówno analytics, jak i (dla porządku) parametry reklamowe.
export function applyConsent(value: ConsentValue): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as { gtag?: (...args: unknown[]) => void };
  if (typeof w.gtag !== "function") return;
  w.gtag("consent", "update", {
    analytics_storage: value,
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  });
}
